import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter } from '@fiverr-private/overlay';
import { Button } from '@fiverr-private/button';
import { Text } from '@fiverr-private/typography';
import { AppI18n } from '../../i18n';

export interface BriefEditSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const BriefEditSuccessModal: React.FC<BriefEditSuccessModalProps> = ({ isOpen, onClose }) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <ModalContent renderWhenClosed>
      <ModalHeader>
        <AppI18n k="brief_edit_success_modal.header" />
      </ModalHeader>
      <ModalBody>
        <Text>
          <AppI18n k="brief_edit_success_modal.body" />
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose}>
          <AppI18n k="brief_edit_success_modal.button" />
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
